import React, { useState, useEffect } from "react";
import { getRequest, postRequest } from "../Common/Utils.js";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import BootstrapTable from "react-bootstrap-table-next";
import { Link, NavLink, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

const TableComponent = ({ selectRow, orderId, selectedProductsData, orderInfo, manufacturersType, allData }) => {
  const [offerdata, setofferdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = React.useState(10);

  const [sort, setsort] = React.useState("");
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const navigate = useLocation()

  useEffect(() => {
    DeliveryFilterList();
  }, [currentPage]);

  useEffect(() => {
    DeliveryFilterList();
  }, [sizePerPageOrg, sort]);

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function ImgLogoFormatter(cellContent, row) {
    return (
      <>
        <img src={row.image} alt="img" width={"50px"} />
      </>
    );
  }
  function FullNameFormatter(cellContent, row) {
    return (
      <>
        {row?.first_name} {row?.last_name}
      </>
    );
  }
  function TypeFormatter(cellContent, row) {
    return (
      <>
        {row?.manufacturer ? <div className="text-start">
        <Link to={`/manufacturers-details/${row?.manufacturer?._id}`}> {row?.manufacturer?.companyName} </Link>
        </div> : 'kulies' }
      </>
    );
  }

  function BusinessFormatter(cellContent, row) {
    return (
      <div style={{ display: "flex" }}>
        <p>{row?.business_id?.name}</p>
      </div>
    );
  }

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {
      dataField: "image",
      text: "Image",
      formatter: ImgLogoFormatter,
      sort: false,
    },

    {
      formatter: FullNameFormatter,
      text: "Full Name",
      sort: false,
    },
    {
      dataField: "email",
      text: "Email",
      sort: false,
    },

    {
      dataField: "phone",
      text: "Phone No.",
      sort: false,
    },
    {
      dataField: "vehicleType",
      text: "Vehicle Type",
      sort: false,
    },
    {
      dataField: "select",
      text: "Select",
      formatter: iconFormatter,
      sort: false,
    },
    {
      dataField: "select",
      text: "Agent Type",
      formatter: TypeFormatter,
      sort: false,
    },
  ];

  const handleChange = (event) => {
    console.log("page value ", event.target.value);
    setSizePerPage(event.target.value);
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
    console.log("sorting  value ", event.target.value);
  };
  const handleReload = () => {
    window.location.reload();
  };


  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          <Link
            className="btn btn-danger"
            to={{
              pathname: manufacturersType === "manufacturers"
                ? `/manufeaturer-assign-confrim-delivery/${orderId}`
                : `/assign-confrim-delivery/${orderId}`,
              state: { row, selectedProductsData, orderInfo, manufacturersType, allData },
            }}
          >
            <i className="fal fa-plus fs-5"></i>
          </Link>

          {/* <button
            type="button"
            className="btn btn-danger"
            onClick={() => navigate}
            // onClick={() => selectRow(row, row._id)}
          >
            <i class="fal fa-plus  fs-5"></i>
          </button> */}
        </div>
      </React.Fragment>
    );
  }

  const limit = 10;

  const DeliveryFilterList = async (page = 0) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: "asc",
      status: "verified",
      active: true
    };

    if (searchText) {
      payload.search = searchText;
    }

    const response = await postRequest(`delivery-agent/list`, payload);
    const data = response?.data;
    // const verifiedData = data?.list?.filter(item => item.status === "verified" && item.active === true);
    // console.log("data", verifiedData);
    setTotalPage(data?.count);
    setCurrentFPage(data?.page);
    setofferdata(data?.list);
    setLoader(false);
  };

  return (
    <>
      <React.Fragment>
        <Row>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={offerdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <div className="d-flex w-50">
                                    <label className="mb-0 text-label">
                                      Page Size
                                    </label>

                                    <select
                                      value={sizePerPageOrg}
                                      onChange={handleChange}
                                      className="form-select"
                                      style={{ width: "10%" }}
                                    >
                                      <option value="10">10</option>
                                      <option value="20">20</option>
                                      <option value="50">50</option>
                                    </select>
                                  </div>
                                  <div className="w-50 text-end">
                                    <div className="d-flex g-3 justify-content-end">
                                      <input
                                        type="search"
                                        placeholder="Search"
                                        value={searchText}
                                        class="form-control"
                                        onChange={(e) =>
                                          setSearchText(e.target.value)
                                        }
                                        style={{ width: "30%" }}
                                      />
                                      <button
                                        onClick={() => {
                                          DeliveryFilterList();
                                        }}
                                        type="button"
                                        className="btn btn-primary mx-2"
                                      >
                                        Search
                                      </button>
                                    </div>
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    </>
  );
};

const DeliveryAgents = ({ orderId,
   show,
  closeModal,
  selectRow,
  selectedProductsData,
  orderInfo,
  manufacturersType,
  allData }) => {
  return (
    <Modal
      isOpen={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered={true}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          Assign Delivery Agents List
        </h5>
        <button
          onClick={() => {
            closeModal();
          }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <TableComponent
          selectRow={selectRow}
          allData={allData}
          manufacturersType={manufacturersType}
          orderId={orderId}
          orderInfo={orderInfo}
          selectedProductsData={selectedProductsData} />
      </div>
    </Modal>
  );
};

export default DeliveryAgents;
